import { z } from "zod";
import { Id } from "../common/ids.js";
import { defineRoute } from "../http/route.js";
import { Conversation } from "./conversation.routes.js";
/** Contact seller (IM-4, card 045): a buyer's conversation with a shop, opened from a product. */
export const contactSeller = defineRoute({
    surface: "tenant",
    auth: "user",
    permission: "conversation:create",
    id: "messaging.shop_conversations.contact",
    method: "POST",
    path: "/v1/products/{productId}/contact",
    marks: ["tenant", "verified", "idem"],
    summary: "Contact a live product's shop: the buyer's one conversation with that shop, opened the first time with an agent the shop's rule picks, and the product card posted in it each time. Not for the seller's own enterprise",
    prd: ["IM-4", "IM-3"],
    request: { params: z.object({ productId: Id }) },
    responses: { 200: { description: "The conversation", schema: Conversation } },
    errors: [
        "AUTH_REQUIRED",
        "TENANT_REQUIRED",
        "PERMISSION_DENIED",
        "ENTERPRISE_NOT_VERIFIED",
        "ENTERPRISE_SUSPENDED",
        "AGREEMENT_ACCEPTANCE_REQUIRED",
        "NOT_FOUND",
        "INVALID_TRANSITION",
        "PROVIDER_UNAVAILABLE",
    ],
});
export const contactSellerRoutes = [contactSeller];
//# sourceMappingURL=contact-seller.routes.js.map